import amazonLogo from "../../assets/amazon.png";
import flipkartLogo from "../../assets/flipkart.png";
import travelAppLogo from "../../assets/travelApp.png";
import storeLogo from "../../assets/store.png";
import ticketLogo from "../../assets/ticket.png";
import anywhereLogo from "../../assets/anywhere.png";
import crossMarkLogo from "../../assets/crossMark.png";
import correctLogo from "../../assets/correct.png";

export const storeBadges = [
  {
    href: "https://play.google.com/store/apps/details?id=com.swapapp.android",
    imgUrl:
      "https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg",
    alt: "Get it on Google Play",
  },
  {
    href: "https://apps.apple.com/in/app/poolmoney-spendeasy/id6737477428",
    imgUrl:
      "https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg",
    alt: "Download on the App Store",
  },
];

export const trustItems = [
  "Secured RD",
];

export const floatingGoals = [
  { label: "👜 New Bag", price: "Rs 12,500", className: "top-8 right-0" },
  { label: "🎁 Gift for her", price: "Rs 8,800", className: "top-44 -right-6" },
  { label: "📱 New Phone", price: "Rs 19,999", className: "bottom-24 -left-6" },
  { label: "✈ Trip", price: "Rs 28,000", className: "bottom-6 right-6" },
];

export const stepItems = [
  {
    number: "1",
    emoji: "GOAL",
    title: "Pick what you want",
    description:
      "Choose your goal, set a date, and let the savings flow run automatically from there.",
  },
  {
    number: "2",
    emoji: "AUTO",
    title: "We manage your money",
    description:
      "Small daily savings get organized into a bank-escrow-backed flow so your plan stays protected.",
  },
  {
    number: "3",
    emoji: "READY",
    title: "You spend stress-free",
    description:
      "When the day arrives your money is already ready, plus you unlock the extra PoolMoney benefit.",
  },
];

export const momentItems = [
  "🎂 For Dad's Birthday",
  "💝 For Wife",
  "👩 For Mom",
  "🎊 For Anniversary",
  "👜 For Myself",
  "💛 For Sister",
  "😎 For Brother",
  "💕 For Girlfriend",
  "👨 Father's Day",
];

export const storeItems = [
  { icon: amazonLogo, name: "Amazon", isImage: true },
  { icon: flipkartLogo, name: "Flipkart", isImage: true  },
  { icon: travelAppLogo, name: "Travel apps", isImage: true  },
  { icon: storeLogo, name: "Any store", isImage: true  },
  { icon: ticketLogo, name: "Tickets", isImage: true  },
  { icon: anywhereLogo, name: "Anywhere", isImage: true  },
];

export const platformTags = [
  "Amazon",
  "Flipkart",
  "Brand store",
  "Reliance Digital",
  "Croma",
  "Travel apps",
  "Booking platforms",
];

export const feelingItems = [
  { icon: crossMarkLogo, label: "No debt trap", tone: "negative", isImage: true },
  { icon: crossMarkLogo, label: 'No "money tight" feeling after spending', tone: "negative", isImage: true },
  { icon: crossMarkLogo, label: "No EMI stress", tone: "negative", isImage: true },
  { icon: correctLogo, label: "Just spend freely", tone: "positive", isImage: true },
];

export const partnerItems = [
  {
    icon: "🎯",
    title: "Access pre-committed buyers",
    description:
      "Reach users who have already saved for your product and come in with strong intent.",
  },
  {
    icon: "📈",
    title: "Incremental sales",
    description:
      "Create additional demand beyond existing channels without cannibalizing current revenue.",
  },
  {
    icon: "✅",
    title: "Higher conversion certainty",
    description:
      "Buyers with money ready convert with less hesitation, fewer abandoned carts, and less friction.",
  },
  {
    icon: "🔒",
    title: "Zero cannibalization",
    description:
      "PoolMoney-driven buyers are additive, giving brands a cleaner partnership story and better ROI.",
  },
];

export const faqItems = [
  {
    question: "Is my money safe?",
    answer:
      "Your money is saved in an RD with RBI-regulated partner banks. PoolMoney does not lend, invest, or use your money.",
  },
  {
    question: "Can I withdraw anytime?",
    answer:
      "Yes. You can stop your plan and withdraw your money anytime. No penalties. No hidden charges.",
  },
  {
    question: "How do I get the 10% benefit?",
    answer:
      "When you're ready to buy, PoolMoney provides exclusive partner discounts. These benefits can be used along with existing store offers and eligible bank card offers.",
  },
  {
    question: "Do I need to change how I shop?",
    answer:
      "No. Buy online or offline, wherever you prefer. PoolMoney is platform-agnostic and works with your existing shopping habits.",
  },
  {
    question: "Do I earn returns while saving?",
    answer:
      "Yes. Your money is saved in an RD with RBI-regulated partner banks and earns interest during the savings period.",
  },
  {
    question: "Is my money locked for years?",
    answer:
      "No. Most goals are short-term, typically 3–12 months, helping you prepare for upcoming purchases without long lock-in periods.",
  },
  {
    question: "What can I save for?",
    answer:
      "Travel, phones, laptops, bikes, gifts, family events, gadgets, weddings, and 1000+ other goals.",
  },
];
